exports = module.exports = require("../node_modules/_css-loader@0.28.11@css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n#app {\n  height: 100%;\n  width: 100%;\n}\n", "", {"version":3,"sources":["F:/develop/JCeshop-wx/src/App.vue"],"names":[],"mappings":";AACA;EACE,aAAa;EACb,YAAY;CACb","file":"App.vue","sourcesContent":["\n#app {\n  height: 100%;\n  width: 100%;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/_css-loader@0.28.11@css-loader?{"sourceMap":true}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-0fe9125a","scoped":false,"hasInlineConfig":false}!./node_modules/_sass-loader@7.1.0@sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=styles&index=0!./src/App.vue
// module id = q6fe
// module chunks = 83